module.exports = __webpack_public_path__ + "static/media/edit.5cf4ea60.svg";